export function codeTagVariable(newVal) {
  if (isNaN(newVal) || newVal === null) return null;
  return newVal;
}

export function codeVariable(variable) {
  if (variable.newValue === undefined || variable.newValue === null || variable.newValue === "") return null;
  if (variable.type >= 16) return codeArrayVariable(variable);
  return variable.newValue;
}

function codeArrayVariable(variable) {
  if (isNaN(variable.arrayIndex) || variable.arrayIndex === null || variable.arrayIndex === "") return null;
  var index = Number(variable.arrayIndex);
  var items = variable.tmpVal ? variable.tmpVal.split(';') : variable.value.split(';');
  if (index < 0 || index >= items.length) return null;
  var newVal = variable.newValue;
  if (newVal === null) return null;
  items[index] = "1:" + newVal;
  variable.tmpVal = items.join(';');
  return variable.tmpVal;
}